<section class="pit-card findings">
  <div class="pit-card__head">
    <div>
      <h3 class="pit-title">
        {{ heading() }}
        @if (hiddenCriticalCount() > 0 && !showAll()) {
          <span class="pit-tag pit-tag--danger findings__hidden"
            >+{{ hiddenCriticalCount() }} críticos</span
          >
        }
      </h3>
      <p class="pit-caption">{{ subheading() }}</p>
    </div>
  </div>

  @if (!shown().length) {
    <p class="pit-text">{{ emptyText() }}</p>
  }

  <!--
    Linhas compactas (protótipo 01): selo · título · o que fazer · fonte · Dispensar/Reativar. A fonte legível fica em
    texto pequeno embaixo do título, com os ids das regras no title, para o analista.
  -->
  <ul class="findings__list">
    @for (finding of shown(); track finding.pointIds.join('|')) {
      @let source = sourceOf(finding);
      <li
        class="finding"
        [class.finding--critical]="finding.level === 'critico' && !finding.dismissed"
        [class.finding--dismissed]="!!finding.dismissed">
        <span class="finding__level">
          <span class="pit-tag" [class]="levels[finding.level].css">{{
            levels[finding.level].label
          }}</span>
        </span>
        <span class="finding__title">
          <b class="pit-strong">{{ finding.title }}</b>
          @if (source.text) {
            <span class="pit-caption finding__source" [title]="source.ids">{{ source.text }}</span>
          }
        </span>
        <span class="pit-text finding__text">{{ finding.text }}</span>
        <span class="finding__action">
          @if (canDismiss()) {
            @if (finding.dismissed) {
              <button
                type="button"
                class="pit-link"
                [disabled]="busy()"
                (click)="undoDismiss.emit(finding)">
                Reativar
              </button>
            } @else if (finding.level !== 'ok') {
              <button
                type="button"
                class="pit-link"
                [disabled]="busy()"
                (click)="dismiss.emit(finding)">
                Dispensar
              </button>
            }
          }
        </span>
        @if (finding.dismissed; as dismissed) {
          <span class="pit-caption finding__dismissed">
            Dispensado por {{ dismissed.by }} em {{ dismissed.at | vaultDateTime }}:
            {{ dismissed.reason }}
          </span>
        }
      </li>
    }
  </ul>

  @if (hasMore()) {
    <button type="button" class="pit-link findings__toggle" (click)="toggle()">
      {{ showAll() ? 'Mostrar só os principais' : moreLabel() }}
    </button>
  }
</section>
